import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import {setFreelancersCountry} from "../../useReducer/actionCreators"
import useOption from "./useOption"

const FreelancersCountryDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Country"
      id="country_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
          externalDispatch(setFreelancersCountry(option.id))
      }}
    />
  )
}
export default FreelancersCountryDropdown
